import { z } from "zod";
import { socialLinksSchema } from "./social-links.js";

export const updateProfileSchema = z
	.object({
		first_name: z.string().min(1, { message: "First name is required" }).max(50),
		last_name: z.string().min(1, { message: "Last name is required" }).max(50),
		photo_url: z.url().optional(),
		bio: z.string().max(500).optional(),
		title: z.string().max(100).optional(),
		organization: z.string().max(100).optional(),
		country: z.string().max(100).optional(),
		city: z.string().max(100).optional(),
		field: z.array(z.string().trim().min(1).max(100)).max(20).optional(),
		social_links: socialLinksSchema.optional(),
	})
	.strict();

export type UpdateProfilePayload = z.infer<typeof updateProfileSchema>;
